<form [formGroup]="vm" [errorMessage]="errorMessage" class="common-form" [simpleMode]="isSimpleMode">
    <ng-container *ngIf="selectType !== SnapSourceSelectTypeE.Single">
        <!-- 已选LUN区域collaps，极简模式不支持 -->
        <n-form-item *ngIf="!isSimpleMode" [label]="i18n.selectedLab" [required]="true">
            <n-advanced #selectedLunToggle id="create-lun-snapshot-advance" [expand]="lunTableExpand"
                [title]="selectedLuns.length" class="advanced-toggle">
            </n-advanced>
        </n-form-item>

        <!-- 源LUN选择表格 -->
        <n-form-item [class.hidden]="!isSimpleMode && (!selectedLunToggle || !selectedLunToggle.expand)"
            [labelHide]="true">
            <n-tip type="failed"
                *ngIf="selectLunValid"
                [content]="i18n.notEnoughErr">
            </n-tip>
            <n-transfer-table
                id="protection_lun_snapshot_create_lun"
                [leftTitle]="i18n.avaiableLunLab"
                [rightTitle]="i18n.selectedLab"
                [leftTip]="isSimpleMode ? '' : i18n.filterDataTip"
                [config]="tableConfig"
                [leftColumnDefs]="columnDefs"
                [rightColumnDefs]="columnDefs"
                [rest]="lunRest"
                [(selection)]="selectedLuns"
                (selectionChange)="lunSelectionChange()">
            </n-transfer-table>
        </n-form-item>
    </ng-container>

    <!-- 极简模式 源LUN放顶部 -->
    <ng-container *ngIf="isSimpleMode && selectType === SnapSourceSelectTypeE.Single">
        <div class="lun-icon-and-label" nTextTips>
            <!-- 图标 -->
            <svg class="icon">
                <use [attr.xlink:href]="'#app-icon-simple-lun'"></use>
            </svg>
            <!-- Label -->
            <span class="lun-name-label">{{inputLuns[0].NAME}}</span>
        </div>
    </ng-container>

    <ng-container *ngIf="showSchedule && showSnap">
        <!-- 请选择保护方式label -->
        <n-form-item [labelHide]="true">
            <div class="simple-step-title mt-40">
                <div class="step-number"><span>2</span></div>
                {{i18n.protectTypeLabel}}
            </div>
        </n-form-item>

        <!-- 快照保护模式类型：加入CDP策略 or 创建单次快照 -->
        <n-form-item [required]="true" [labelHide]="true">
            <n-radio-group formControlName="protectType" [cardStyle]="true" (onChange)="protectTypeChange($event)">
                <!-- 加入CDP策略 -->
                <n-radio id="create-lun-snap-protect-cdp-schedule-id" [value]="SnapProtectTypeE.CdpSchedule"
                    [icon]="'#app-icon-protection-s-snapshot-once'" [title]="i18n.addScheduleLabel"
                    [tip]="i18n.addScheduleCardTip" [ngStyle]="{'width': multiTitleWidth}">
                </n-radio>

                <!-- 创建单次快照 -->
                <n-radio id="create-lun-snap-protect-snap-id" [value]="SnapProtectTypeE.Snap"
                    [icon]="'#app-icon-protection-s-snapshot-policy'" [title]="i18n.singleSnapLabel"
                    [tip]="i18n.singleSnapCardTip" [ngStyle]="{'width': multiTitleWidth}">
                </n-radio>
            </n-radio-group>
        </n-form-item>
    </ng-container>

    <!-- 加入CDP策略。仅极简模式主页面支持 -->
    <n-form-item [labelHide]="true" [class.hidden]="vmValue.protectType !== SnapProtectTypeE.CdpSchedule">
        <div class="simple-step-title" [ngClass]="{'mt-40': showSnap}">
            <div class="step-number" *ngIf="showSchedule && showSnap"><span>3</span></div>
            {{i18n.selectScheduleLabel}}
        </div>
    </n-form-item>

    <n-form-item *ngIf="showSchedule" [labelHide]="true" [required]="true"
        [class.hidden]="vmValue.protectType !== SnapProtectTypeE.CdpSchedule">

        <!-- 添加策略按钮 -->
        <div class="table-operation interval-10 mt-16 mb-16">
            <n-button-group [items]="scheduleBtnGroup">
            </n-button-group>
        </div>

        <!-- 策略列表 -->
        <n-data-card #scheduleDataCard
            id="cdp-schedule-data-card"
            [config]="dataCardConfig"
            [multiCardStyle]="true"
            [multiCardWidth]="multiCardWidth"
            [defaultData]="scheduleDefaultData"
            [initSelectVal]="initSelectVal"
            [showDefaultWhenNoData]="true"
            [supportSelectedFirstData]="!modifySchedule"
            [rest]="getBatchScheduleRest"
            formControlName="schedule">
        </n-data-card>
    </n-form-item>

    <!-- 极简模式下，快照参数放到高级设置-->
    <n-collapse-list *ngIf="isSimpleMode"
        [class.hidden]="vmValue.protectType !== SnapProtectTypeE.Snap"
        id="advance-setting-collapse"
        [title]="i18n.advancedSettingTitle"
        class="advance-setting-collapse">
        <ng-container [ngTemplateOutlet]="snapForm">
        </ng-container>
    </n-collapse-list>

    <ng-container *ngIf="!isSimpleMode" [ngTemplateOutlet]="snapForm">
    </ng-container>

    <!-- 快照相关参数表单 -->
    <ng-template #snapForm>
        <!-- 创建单次快照 -->
        <!-- 快照创建模式。1、新创建 2、选目标LUN -->
        <n-form-item [label]="i18n.createModeLab" [class.hidden]="vmValue.protectType !== SnapProtectTypeE.Snap">
            <n-radio-group formControlName="createType" (onChange)="createTypeChanged($event)">
                <n-radio id="new_create_snapshot" [value]="SnapshotCreateModeE.newCreate">
                    <span>{{i18n.newCreateSnapshotLab}}</span>
                </n-radio>
                <n-radio id="target_lun_create_snapshot" [value]="SnapshotCreateModeE.targetObjCreate"
                    [disabled]="selectedLuns.length !== 1"
                    [nTooltip]="selectedLuns.length !== 1 ? i18n.targetLunErrorTip : ''">
                    <span>{{i18n.selectTargetLunLab}}</span>
                </n-radio>
            </n-radio-group>
        </n-form-item>

        <!-- 目标LUN -->
        <n-form-item [label]="i18n.targetLunLabel" [required]="true" [helpContent]="i18n.targetLunSnapshotTip"
            [class.hidden]="vmValue.protectType === SnapProtectTypeE.CdpSchedule || vmValue.createType === SnapshotCreateModeE.newCreate">
        <n-select id="select_target_lun" [rest]="targetLunRest" labelField="name" valueField="ID" [limit]="100"
            [filter]="true" formControlName="selectTargetLUN" (onChange)="targetLunSelectChange($event)">
        </n-select>
        </n-form-item>

        <!-- 名称 -->
        <n-form-item [label]="i18n.name" [class.hidden]="vmValue.protectType !== SnapProtectTypeE.Snap">
        <input id="pro_create_snapshot_name" nInput type="text" [placeholder]="placeholderName" formControlName="name">
        </n-form-item>

        <!-- 描述 -->
        <n-form-item [label]="i18n.des" [class.hidden]="vmValue.protectType !== SnapProtectTypeE.Snap">
        <textarea id="pro_create_snapshot_des" nTextarea formControlName="des"
            [placeholder]="i18n.placeholderDes"></textarea>
        </n-form-item>
    </ng-template>

    <!-- 源LUN -->
    <n-form-item *ngIf="!isSimpleMode && selectType === SnapSourceSelectTypeE.Single" [label]="i18n.sourceLUN">
        <span>{{inputLuns[0].NAME}}</span>
    </n-form-item>

    <!-- 租户 -->
    <n-form-item *ngIf="selectType === SnapSourceSelectTypeE.Single && !isSimpleMode" [label]="i18n.vstoreLabel">
        <div class="n-form-item-text">{{inputLuns[0].vstoreName}}</div>
    </n-form-item>
</form>

<!-- 创建快照高危提示中的表格 -->
<ng-template #targetLunTemplate>
    <n-data-table id="lun_create_snapshot_target_Lun_table" style="height: 2rem;" [columnDefs]="targetLunColumnDefs"
        [data]="[selectedTargetLUN]">
    </n-data-table>
</ng-template>

<!-- 修改策略高危提示中的表格 -->
<ng-template #modifyScheduleTableTemplate>
    <n-data-table id="modify-lun-schedule-table" style="height: 2rem;" [columnDefs]="modifyScheduleTableColumnDefs"
        [data]="inputLuns">
    </n-data-table>
</ng-template>
